var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._l(_vm.allApplicants, function (applicant, applicantIndex) {
        return _c(
          "div",
          { key: applicantIndex },
          [
            _vm.isApplicantVisibleFromFillOut(applicant.id) || !_vm.IS_FILL_OUT
              ? _c(
                  "page-summary-section-group-layout",
                  { attrs: { "show-divider": "" } },
                  [
                    _c(
                      "section-title",
                      { attrs: { "title-type": "subtitle" } },
                      [
                        _c("span", { staticClass: "bold" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.applicantNameFromIndex(applicantIndex)
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isInvalid(applicant)
                          ? _c("application-section-error-icon", {
                              attrs: {
                                id: "error-tooltip-" + applicant.id,
                                "show-errors": _vm.showErrors,
                                "is-first-item":
                                  applicant.id === _vm.firstErrorId,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "text-light-gray":
                                    !_vm.getApplicantEmail(applicant),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getApplicantEmail(applicant) ||
                                      _vm.$t(
                                        "application-standalone.pages.pleaseReviewThisSection"
                                      )
                                  ) + "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "auto" } }, [
                          applicantIndex > 0 &&
                          !_vm.IS_FILL_OUT &&
                          _vm.isApplicantVisibleFromFillOut(applicant.id)
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-danger mr-2 my-lg-0 my-3",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDeletionModal({
                                        applicantIndex: applicantIndex,
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("global.words.delete")) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: {
                                    title: _vm.$t(
                                      "application-standalone.pages.applicants.disabledEditApplicant"
                                    ),
                                    disabled: _vm.isApplicantVisibleFromFillOut(
                                      applicant.id
                                    ),
                                  },
                                  expression:
                                    "{\n              title: $t(\n                'application-standalone.pages.applicants.disabledEditApplicant'\n              ),\n              disabled: isApplicantVisibleFromFillOut(applicant.id)\n            }",
                                },
                              ],
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary text-capitalize skip-disable-all-inputs",
                                  attrs: {
                                    disabled:
                                      applicant.index !== -1 &&
                                      !_vm.isApplicantVisibleFromFillOut(
                                        applicant.id
                                      ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleNavigation(
                                        applicantIndex,
                                        applicant.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.allowEdit
                                    ? _c("icon", {
                                        staticClass: "text-primary mr-1",
                                        attrs: { name: "pencil" },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.editButtonText) +
                                      "\n            "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      !_vm.IS_FILL_OUT
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link text-primary mb-4",
                    on: { click: _vm.handleAddAnotherApplicant },
                  },
                  [
                    _vm._v(
                      "\n        +\n        " +
                        _vm._s(
                          _vm.$t(
                            "application-standalone.pages.applicants.addAnotherApplicant"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("remove-component-modal", {
        ref: "removeComponentModal",
        attrs: { text: _vm.modalText },
        on: { accept: _vm.handleDelete },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }